import { createClient } from '@supabase/supabase-js';

// These would typically come from environment variables
const supabaseUrl =
  import.meta.env.VITE_SUPABASE_URL || 'https://placeholder.supabase.co';
const supabaseAnonKey =
  import.meta.env.VITE_SUPABASE_ANON_KEY || 'placeholder-anon-key';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Helper function to format child email
export const formatChildEmail = (username, guardianCode) => {
  return `${guardianCode}__${username}@learndle.learndle`;
};

// Helper function to parse child username from email
export const parseChildUsername = (email) => {
  const parts = email.split('@')[0].split('__');
  return parts.length > 1 ? parts[1] : parts[0];
};

// Helper function to parse guardian code from email
export const parseGuardianCode = (email) => {
  const parts = email.split('@')[0].split('__');
  return parts.length > 1 ? parts[0] : '';
};
